/**
 * Brand ownership of a device, shared by SMRS invoice generation and the Sales Report (KAN-42, KAN-43).
 * A store can host devices of several brands, so revenue is attributed per device:
 * a branded device must match the selected brand; a legacy device without a brand is a photobooth
 * (backfilled to K-Photo LaVie) and never counts for Konobox. With no brand id nothing is filtered.
 */
export function deviceBelongsToBrand(dev: any, brandId: string | undefined | null, brandName: string | undefined | null): boolean {
  if (!brandId) return true;
  const devBrandId = String(dev?.brandId || '').trim();
  if (devBrandId) return devBrandId === brandId;
  return String(brandName || '').trim().toLowerCase() !== 'konobox';
}
